import { Injectable } from '@angular/core';
import Queries from '../data/queries/student-inbox';
import { Apollo, ApolloBase } from 'apollo-angular';
import {
  InboxUpdateInput,
  WordMetadata,
  WordQueryResponse,
} from '../types/student-inbox.types';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StudentInboxService {
  public apollo: ApolloBase;

  constructor(private apolloProvider: Apollo) {
    this.apollo = apolloProvider.use('studentInbox');
  }

  async updateActivityStatus(input: InboxUpdateInput): Promise<boolean> {
    if (!input.activityId) {
      console.warn('Student Inbox: Update Activity Failed. No activityId');
      return false;
    }
    return this.apollo
      .mutate({
        mutation: Queries.UPDATE_ACTIVITY_MUTEX,
        variables: input,
        errorPolicy: 'all',
      })
      .toPromise()
      .then(response => {
        if (!response) {
          console.log('Student Inbox: Update Activity Failed. No response');
          return false;
        } else if (response.error) {
          console.log(
            'Student Inbox: Update Activity Failed. ',
            response.error
          );
          return false;
        }

        console.log(
          'Student Inbox: Update Activity Succeeded. ',
          response.data
        );
        return true;
      })
      .catch(error => {
        const errorMessage =
          error instanceof Error ? error.message : 'Unknown error';
        console.error(
          'Student Inbox Service - updateActivityStatus query failed:',
          errorMessage
        );
        throw new Error(
          `Student Inbox Service - updateActivityStatus query failed > ${errorMessage}`
        );
      });
  }

  async getWordMetadata(word: string): Promise<WordMetadata> {
    return new Promise((resolve, reject) => {
      this.apollo
        .watchQuery<WordQueryResponse>({
          query: Queries.GET_WORD_METADATA,
          variables: { word: word.toUpperCase() },
        })
        .valueChanges.pipe(
          filter(result => !result.loading && !!result.data?.word),
          map(result => ({
            word: result.data?.word?.items?.[0]?.WORD,
            phonemes: result.data?.word?.items?.[0]?.PHON,
            morphemes: result.data?.word?.items?.[0]?.MORPHEME,
            phonemeVideoUrl:
              result.data?.word?.items?.[0]?.PHONEME_VIDEO_URL ?? '',
          }))
        )
        .subscribe({
          next: data => {
            resolve(data as WordMetadata);
          },
          error: error => {
            console.error(
              'Student Inbox Service - getWordMetadata query failed:',
              error
            );
            reject(error);
          },
        });
    });
  }
}
